import useQueryOnboardingFlowStepHeader from '@/integrations/content/content-modules/onboarding-flow-step-header/onboarding-flow-step-header.hooks';
import OnboardingFlowStepHeaderModule from './onboarding-flow-step-header-module';

export type OnboardingFlowStepHeaderModuleContainerProps =
  Content.Components['OnboardingFlowStepHeaderHeadlessModuleDto'];

const OnboardingFlowStepHeaderModuleContainer = ({
  id,
  pageId,
}: OnboardingFlowStepHeaderModuleContainerProps) => {
  const { data, isFetching, isLoading } = useQueryOnboardingFlowStepHeader({
    parameters: {
      id,
      pageId,
    },
  });

  if (isFetching || isLoading) {
    return <OnboardingFlowStepHeaderModule isLoading />;
  }

  if (!data) return null;

  return <OnboardingFlowStepHeaderModule {...data} />;
};

OnboardingFlowStepHeaderModuleContainer.displayName =
  'OnboardingFlowStepHeaderModuleContainer';

export default OnboardingFlowStepHeaderModuleContainer;
